import { createRouter, createWebHistory } from 'vue-router'

import Ungdommer from '@/modules/ungdommer/routes'
import Skrivebord from '@/modules/skrivebord/routes'
import Notater from '@/modules/notater/routes'
import Oppgaver from '@/modules/oppgaver/routes'
import SentraleOppgaver from '@/modules/sentraleOppgaver/routes'

import Brukere from '@/modules/brukere/routes'
import Kontaktpersoner from '@/modules/kontaktpersoner/routes'
import Profil from '@/modules/profil/routes'
import UngdomGrupper from '@/modules/ungdomgrupper/routes'

const routes = [
  {
    path: '/',
    children: Skrivebord
  },
  {
    path: '/ungdommer',
    children: Ungdommer
  },
  {
    path: '/notater',
    children: Notater
  },
  {
    path: '/oppgaver',
    children: Oppgaver
  },
  {
    path: '/sentraleOppgaver',
    children: SentraleOppgaver
  },

  {
    path: '/brukere',
    children: Brukere
  },
  {
    path: '/kontaktpersoner',
    children: Kontaktpersoner
  },
  {
    path: '/profil',
    children: Profil
  },
  {
    path: '/ungdomgrupper',
    children: UngdomGrupper
  },
  {
    path: '/client-auth/response',
    redirect: { path: '/', query: {} }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(_to, _from, _savedPosition) {
    return { top: 0, left: 0 }
  }
})

export default router
